import React from 'react';
import {
  Button,
  FormGroupRow,
  HorizontalFormControl,
  SelectBanner,
} from '../../../../common/components';
import { Col, Modal, Row, Form } from 'react-bootstrap';
import { Field } from 'redux-form';
import {
  CheckboxUnlabeled,
  TextField,
  SelectField,
} from '../../../../common/components/ReduxFormField';
import UploadCropComponent from '../../../../common/components/Upload/UploadCrop';
import { triggerFileUpload } from '../../../../common/components/Upload/UploadRedux';
import BannerPreview from '../BannerPreview/BannerPreview';
import { updateCampaignBannerMetadata } from '../../redux/campaignActions';
import AsyncMultiSelectMenu from '../../../../common/components/SelectMenu/AsyncMultiSelectMenu';

class CampaignBannerModal extends React.Component {
  state = {
    showModal: false,
    errors: false,
    bannerText: '',
    discountMessage: '',
    whereToApply: '',
    page: '',
    timeIdle: '',
    bannerImage: '',
    phone: '',
    processing: false,
  };

  componentWillReceiveProps() {
    if (this.state.errors) {
      this.setState({
        errors: false,
      });
    }
  }

  // handleRestrictToTracking(value) {
  //   const { dispatch, change, formValues } = this.props
  //   if (value) {
  //     const brokers = formValues.data.relationships.brokers.data.map((broker) => {
  //       return broker.id
  //     })
  //     dispatch(change('data.attributes.metadata.banner.brokers', brokers))
  //   }
  //   else {
  //     dispatch(change('data.attributes.metadata.banner.brokers', ''))
  //   }
  // }

  openBannerModal = () => {
    const {
      formValues,
      dispatch,
      change,
      // channels,
      // bannerPhone,
      // bannerText,
      discount,
    } = this.props;

    const banner = formValues.data?.attributes?.metadata?.banner;
    const {
      banner_text: bannerText,
      discount_message: discountMessage,
      banner_info: whereToApply,
      page,
      time_idle: timeIdle,
      files,
      phone,
    } = banner ?? {};

    this.setState({
      showModal: true,
      bannerText: bannerText ?? '',
      discountMessage: discountMessage ?? '',
      whereToApply: whereToApply ?? '',
      page: page ?? '',
      timeIdle: timeIdle ?? '',
      bannerImage: files?.data ?? '',
      phone: phone ?? '',
    });

    if (discountMessage !== '') {
      dispatch(
        change(
          'data.attributes.metadata.banner.discount_message',
          'Save ' + discount + '%',
        ),
      );
    }
    if (!banner) {
      dispatch(
        change(
          'data.attributes.metadata.banner.banner_info',
          'Enter your voucher code on the Scheme Choice page (right hand side) to apply your discount.',
        ),
      );
    }
  };

  saveAndCloseModal = (bannerText, whereToApply, page, timeIdle, bannerImage) => () => {
    const { dispatch, change, discount, updateCampaignBanner, formValues } = this.props;

    if (!bannerText || !whereToApply || !page || !timeIdle || !bannerImage) {
      this.setState({
        errors: true,
      });
    }

    if (bannerText && whereToApply && page && timeIdle && bannerImage) {
      this.setState({
        processing: true,
      });

      setTimeout(
        () =>
          this.setState({
            showModal: false,
            processing: false,
          }),
        1000,
      );
    }

    const discountMessage = discountMessage ? discountMessage : `Save ${discount}%`;
    this.setState({ discountMessage });
    Promise.resolve(
      dispatch(
        change('data.attributes.metadata.banner.discount_message', discountMessage),
      ),
    ).then(() => {
      if (updateCampaignBanner) {
        dispatch(updateCampaignBannerMetadata(formValues));
      }
    });
  };

  cancelAndCloseModal = () => {
    const { dispatch, change } = this.props;
    const {
      bannerText,
      whereToApply,
      page,
      timeIdle,
      bannerImage,
      phone,
      discountMessage,
    } = this.state;

    dispatch(change('data.attributes.metadata.banner.banner_text', bannerText));
    dispatch(change('data.attributes.metadata.banner.discount_message', discountMessage));
    dispatch(change('data.attributes.metadata.banner.banner_info', whereToApply));
    dispatch(change('data.attributes.metadata.banner.page', page));
    dispatch(change('data.attributes.metadata.banner.time_idle', timeIdle));
    dispatch(change('data.attributes.metadata.banner.files.data', bannerImage));
    dispatch(change('data.attributes.metadata.banner.phone', phone));

    this.setState({
      showModal: false,
    });
  };

  startUpload = () => {
    const { dispatch } = this.props;

    dispatch(triggerFileUpload());
  };

  handleUploadComplete = (e) => {
    const { dispatch, change } = this.props;
    //dispatch(refreshData('/files'));
    dispatch(change('data.attributes.metadata.banner.files.data', e.data));
  };

  render() {
    const {
      code,
      discount,
      bannerText,
      discountMessage,
      whereToApply,
      page,
      timeIdle,
      bannerImage,
      channels,
      formValues,
    } = this.props;
    const hasB2CChannel = channels?.reduce((carry, channel) => {
      return carry || channel?.attributes?.channel_type === 'B2C';
    }, false);


    return (
      <div>
        <Button
          size="large"
          label={bannerText ? 'Edit Campaign Banner' : 'Add Campaign Banner'}
          className="pull-right campaign-banner-btn"
          handleClick={this.openBannerModal}
          disabled={!code || !discount || !hasB2CChannel}
        />

        <Modal
          bsSize="large"
          show={this.state.showModal}
          onHide={this.cancelAndCloseModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Campaign Banner</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal>
              <Row>
                <Col sm={6}>
                  <Field
                    name="data.attributes.metadata.banner.banner_text"
                    type={'textarea'}
                    component={TextField}
                    maxLength={50}
                    labelSize={4}
                    label="Banner Text"
                    smFieldSize={8}
                    smLableFieldSize={4}
                  />

                  <Field
                    name="data.attributes.metadata.banner.banner_info"
                    type={'textarea'}
                    component={TextField}
                    labelSize={4}
                    label="Where do I apply my code?"
                    smFieldSize={8}
                    smLableFieldSize={4}
                  />
                  <Field
                    name="data.attributes.metadata.banner.discount_message"
                    type={'textarea'}
                    component={TextField}
                    labelSize={4}
                    label="Discount Message"
                    smFieldSize={8}
                    smLableFieldSize={4}
                  />

                  <Field
                    name="data.attributes.metadata.banner.enabled"
                    label={<strong>Enable Campaign Banner?</strong>}
                    component={CheckboxUnlabeled}
                    positionTop
                    inline
                    labelSize={4}
                    options={[{ label: '', value: true }]}
                  />
                </Col>
                <Col sm={6}>
                  <Field
                    name="data.attributes.metadata.banner.phone"
                    fieldSize={8}
                    component={HorizontalFormControl}
                    labelSize={4}
                    object
                    label="Phone Number"
                  />

                  <Field
                    name="data.attributes.metadata.banner.page"
                    label="Page"
                    fieldSize={8}
                    labelSize={4}
                    options={pageOptions}
                    isMulti
                    component={SelectField}
                  />

                  <Field
                    name="data.attributes.metadata.banner.time_idle"
                    label="Time Idle"
                    fieldSize={8}
                    labelSize={4}
                    options={timeIdleOptions}
                    component={SelectField}
                  />

                  <Field
                    name="data.attributes.metadata.banner.restrict_to_tracking"
                    //onChange={(e, value) => this.handleRestrictToTracking(value)}
                    label="Tracking Link only"
                    labelSize={4}
                    component={CheckboxUnlabeled}
                    inline
                    options={[{ label: '', value: true }]}
                  />

                  {formValues?.data?.attributes?.metadata?.banner
                    ?.restrict_to_tracking && (

                    <FormGroupRow label="Tracking Links" labelSize={4}>
                      <Field
                        name="data.attributes.metadata.banner.brokers"
                        preSelectedOptions={
                          formValues?.data?.attributes?.metadata?.banner?.brokers ?? []
                        }
                        key={'brokersTracking'}
                        filters={[{ type: 'broker_type', match: 'tracking' }]}
                        url={'/brokers?'}
                        component={AsyncMultiSelectMenu}
                      />
                    </FormGroupRow>
                  )}

                  <Field
                    name="data.attributes.metadata.banner.files.data"
                    fieldSize={8}
                    component={SelectBanner}
                    filter={'?filter[location]=files/banners'}
                    labelSize={4}
                    isObject
                    label="Banner Image"
                  />
                  <UploadCropComponent
                    onComplete={this.handleUploadComplete}
                    width={385}
                    height={302}
                    circle={false}
                    askForFilename={true}
                    location={'/banners'}
                  />
                  <Button className="pull-right" handleClick={this.startUpload}>
                    upload image
                  </Button>
                </Col>
                <Col sm={12}>
                  <hr id="second-row" />
                </Col>
                {bannerImage && code && discount ? (
                  <Col sm={12}>
                    <BannerPreview
                      code={code}
                      discount={discount}
                      bannerText={bannerText}
                      discountMessage={discountMessage}
                      whereToApply={whereToApply}
                      page={page}
                      timeIdle={timeIdle}
                      bannerImage={bannerImage}
                      processing={this.state.processing}
                      {...this.props}
                    />
                  </Col>
                ) : (
                  <Col sm={12}>Preview is not available</Col>
                )}
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              bsStyle="primary"
              className="campaign-banner-btn"
              handleClick={this.saveAndCloseModal(
                bannerText,
                whereToApply,
                page,
                timeIdle,
                bannerImage,
              )}
              disabled={this.state.errors}
            >
              Save
            </Button>
            <Button
              bsStyle="default"
              className="pull-left"
              handleClick={this.cancelAndCloseModal}
            >
              Cancel
            </Button>
            {this.state.errors && (
              <div className="error-container">Error: All fields are required</div>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const pageOptions = [
  { label: 'all-pages', value: 'all-pages' },
  { label: 'quote - trip details', value: '/trip-details' },
  { label: 'quote - medical declaration', value: '/medical-declaration' },
  { label: 'quote - additional cover', value: '/additional-cover' },
  { label: 'quote - cover choice', value: '/cover-choice' },
  { label: 'quote - travellers details', value: '/about-you' },
  { label: 'quote - payment', value: '/payment' },
];

const timeIdleOptions = [
  { label: '5 sec', value: 5000 },
  { label: '10 sec', value: 10000 },
  { label: '15 sec', value: 15000 },
  { label: '20 sec', value: 20000 },
  { label: '30 sec', value: 30000 },
  { label: '40 sec', value: 40000 },
  { label: '60 sec', value: 60000 },
  { label: '90 sec', value: 90000 },
  { label: '120 sec', value: 120000 },
];

export default CampaignBannerModal;
